import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { NamePath } from 'antd/lib/form/interface';

import Textarea from '@/components/ui/Textarea';

const { useFormInstance, useWatch } = Form;

interface JobElementProps {
	fieldName: NamePath;
}

export function JobElement({ fieldName }: JobElementProps) {
	const form = useFormInstance();
	const { setFieldValue } = useFormInstance();

	const jobElement = useWatch(fieldName, form);

	setFieldValue(fieldName, jobElement);

	return (
		<Col xs={24} sm={24}>
			<Form.Item name={fieldName} label={I18n.get('Job element')} labelCol={{ span: 24 }}>
				<Textarea
					style={{ width: '100%' }}
					showCount
					allowClear
					maxLength={500}
					rows={7}
					placeholder={I18n.get('Job element')}
				/>
			</Form.Item>
		</Col>
	);
}
